import {
	ADD_FIELDS_VALUE,
	ADD_FIELDS_VALUE_SINGLE,
	SET_CANVAS_PLAYING,
	SET_CONVERT_ING,
	ADD_TRANSITION_DATA,
	MOD_CREATE_VIDEO,
	MOD_VERSION_LIST,
	ADD_VERSION_LIST,
} from '../constact'


const defaultState = {
	fieldsValue: {}, // 表单数据
	canvasPlaying: false, // canvas 绘制中
	convertIng: false, //上传或保存中
	currentPreview: '', // 当前播放的from
	transitionData: [], // 播放前转的数据
	versionPreviewVisible: false, // 是否展示多版本（video第二步）
	versionList: [], // 多版本数据
}
export function addFieldsValue(data) {
	return {
		type: ADD_FIELDS_VALUE,
		data
	}
}
export function addFieldsValueSingle(data) {
	return {
		type: ADD_FIELDS_VALUE_SINGLE,
		data
	}
}
export function setCanvasPlaying(data) {
	return {
		type: SET_CANVAS_PLAYING,
		data
	}
}

export function setConvertIng(data) {
	return {
		type: SET_CONVERT_ING,
		data
	}
}
export function addTrasitionData(data) {
	return {
		type: ADD_TRANSITION_DATA,
		data
	}
}
export function modCreateVideo(data) {
	return {
		type: MOD_CREATE_VIDEO,
		data
	}
}
export function modVersionList(data) {
	return {
		type: MOD_VERSION_LIST,
		data
	}
}
export function addVersionList(data) {
	return {
		type: ADD_VERSION_LIST,
		data
	}
}

const createVideo = (state = defaultState, action) => {
	if(action.type === ADD_FIELDS_VALUE) {
		const newState = JSON.parse(JSON.stringify(state))
		const fieldsValue = action.data
		Object.keys(fieldsValue).forEach(key => {
			if(!fieldsValue[key]) delete fieldsValue[key]
		})
		newState.fieldsValue = action.data
		return newState
	}
	if(action.type === ADD_FIELDS_VALUE_SINGLE) {
		const newState = JSON.parse(JSON.stringify(state))
		action.data.forEach(item => {
			newState.fieldsValue[item.key] = item.value
		})
		return newState
	}
	if(action.type === SET_CANVAS_PLAYING) {
		const newState = JSON.parse(JSON.stringify(state))
		const { status, from } = action.data
		newState.canvasPlaying = status
		newState.currentPreview = from ? from : ''
		return newState
	}
	if(action.type === SET_CONVERT_ING) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.convertIng = action.data
		return newState
	}
	if(action.type === ADD_TRANSITION_DATA) {
		const newState = JSON.parse(JSON.stringify(state))
		const { from, data } = action.data
		const transitionData = []
		transitionData.push({from, data})
		newState.transitionData = transitionData
		return newState
	}
	// 修改state的key value
	if(action.type === MOD_CREATE_VIDEO) {
		const newState = JSON.parse(JSON.stringify(state))
		const data = action.data
		Object.keys(data).forEach(key => {
			newState[key] = data[key]
		})
		return newState
	}
	// 修改versionList的某个值
	if(action.type === MOD_VERSION_LIST) {
		const newState = JSON.parse(JSON.stringify(state))
		const { data,index } = action.data
		const versionList = newState.versionList
		console.log(data)
		Object.keys(data).forEach(key => {
			versionList[index][key] = data[key]
		})
		return newState
	}
	// 生成多版本list，编辑时仅一个版本, + 清空传[]
	if(action.type === ADD_VERSION_LIST) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.versionList = action.data
		return newState
	}
	return state
}
export default createVideo